import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
// import PropTypes from 'prop-types'
import { Route, Switch } from 'react-router-dom'

import PrivateRoute from './../../../component/PrivateRoute'
import NotFound from './../../NotFound'

import { setPageTitle } from './../../../actions'
import { startWatchingOrganization, stopWatchingOrganization } from './../../../actions/Admin'

import TESubNavbar from './../../../component/Navigation/TESubNavbar'

import Users from './Users'
import Details from './Details'

// import styles from './styles'

class Organization extends Component {
	componentDidMount() {
		const { match, setPageTitle, startWatchingOrganization } = this.props
		const { uid } = match.params
		setPageTitle('Organization')
		startWatchingOrganization(uid)
	}
	componentWillUnmount() {
		this.props.stopWatchingOrganization()
	}

	render() {
		const { uid } = this.props.match.params

		return (
			<Fragment>
				<TESubNavbar
					links={[
						{
							title: 'Users',
							to: `/admin/organizations/${uid}/users`,
						},
						{
							title: 'Details',
							to: `/admin/organizations/${uid}/details`,
						},
					]}
				/>
				<Switch>
					<PrivateRoute
						path="/admin/organizations/:uid/users"
						component={Users}
						requiredUserType="admin"
					/>
					<PrivateRoute
						path="/admin/organizations/:uid/details"
						component={Details}
						requiredUserType="admin"
					/>

					<Route component={NotFound} />
				</Switch>
			</Fragment>
		)
	}
}

Organization.propTypes = {}

Organization.defaultProps = {}

const mapStateToProps = (state) => {
	return {}
}

export default connect(
	mapStateToProps,
	{
		setPageTitle,
		startWatchingOrganization,
		stopWatchingOrganization,
	}
)(Organization)
